import React, { useEffect, useState } from 'react';

const EmployerProfiles = () => {
    const [employers, setEmployers] = useState([]);

    useEffect(() => {
        const fetchEmployers = async () => {
            try {
                const response = await fetch('http://127.0.0.1:5000/employers');
                if (response.ok) {
                    const data = await response.json();
                    setEmployers(data);
                } else {
                    console.error('Failed to fetch employer profiles:', await response.json());
                }
            } catch (err) {
                console.error('Error fetching employers:', err);
            }
        };

        fetchEmployers();
    }, []);

    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <h2>Employer Profiles</h2>
            {employers.length > 0 ? (
                <ul>
                    {employers.map((employer) => (
                        <li key={employer.id}>
                            <strong>{employer.organization_name}</strong> - {employer.contact_name} ({employer.job_title})
                            <p>Hiring Needs: {employer.hiring_needs}</p>
                            <p>Tenure: {employer.tenure}</p>
                            <p>Created At: {employer.created_at}</p>
                        </li>
                    ))}
                </ul>
            ) : (
                <p>No employer profiles available.</p>
            )}
        </div>
    );
};

export default EmployerProfiles;

